module.exports = __webpack_public_path__ + "f7ba55499e1c3a2a92072da114052559.svg";